import { render, staticRenderFns } from "./OrganisationManage.vue?vue&type=template&id=2247371e&"
import script from "./OrganisationManage.vue?vue&type=script&lang=ts&"
export * from "./OrganisationManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports